import React from 'react';
import { useTranslation } from 'react-i18next';

const InkPropertiesForm = ({ editData, onFieldChange, disabled = false }) => {
  const { t } = useTranslation('warehouse');
  const handleFieldChange = (field, value) => {
    onFieldChange(field, value);
  };

  return (
    <div className="form-section">
      <h3>{t('inkPropertiesForm.title')}</h3>
      <div className="form-grid">
        <div className="form-group">
          <label>{t('inkPropertiesForm.inkType')}</label>
          <select
            value={editData.ink_type || ''}
            onChange={(e) => handleFieldChange('ink_type', e.target.value)}
            disabled={disabled}
          >
            <option value="" disabled hidden>{t('inkPropertiesForm.selectInkType')}</option>
            <option value="WATER_BASED">{t('inkPropertiesForm.types.WATER_BASED')}</option>
            <option value="SOLVENT_BASED">{t('inkPropertiesForm.types.SOLVENT_BASED')}</option>
            <option value="UV_CURABLE">{t('inkPropertiesForm.types.UV_CURABLE')}</option>
            <option value="LATEX">{t('inkPropertiesForm.types.LATEX')}</option>
          </select>
        </div>

        <div className="form-group">
          <label>{t('inkPropertiesForm.viscosity')}</label>
          <input
            type="number"
            step="0.01"
            value={editData.viscosity || ''}
            onChange={(e) => handleFieldChange('viscosity', parseFloat(e.target.value) || null)}
            disabled={disabled}
            placeholder={t('inkPropertiesForm.viscosityPlaceholder')}
          />
        </div>

        <div className="form-group">
          <label>{t('inkPropertiesForm.opacity')}</label>
          <input
            type="number"
            step="0.01"
            min="0"
            max="100"
            value={editData.opacity || ''}
            onChange={(e) => handleFieldChange('opacity', parseFloat(e.target.value) || null)}
            disabled={disabled}
            placeholder={t('inkPropertiesForm.opacityPlaceholder')}
          />
        </div>

        <div className="form-group">
          <label>{t('inkPropertiesForm.dryingTime')}</label>
          <input
            type="number"
            value={editData.drying_time_minutes || ''}
            onChange={(e) => handleFieldChange('drying_time_minutes', parseInt(e.target.value) || null)}
            disabled={disabled}
            placeholder={t('inkPropertiesForm.dryingTimePlaceholder')}
          />
        </div>

        <div className="form-group">
          <label>{t('inkPropertiesForm.coverage')}</label>
          <input
            type="number"
            step="0.01"
            value={editData.coverage_sqm_per_liter || ''}
            onChange={(e) => handleFieldChange('coverage_sqm_per_liter', parseFloat(e.target.value) || null)}
            disabled={disabled}
            placeholder={t('inkPropertiesForm.coveragePlaceholder')}
          />
        </div>

        <div className="form-group">
          <label>{t('inkPropertiesForm.pantoneMatch')}</label>
          <input
            type="text"
            value={editData.pantone_match || ''}
            onChange={(e) => handleFieldChange('pantone_match', e.target.value)}
            disabled={disabled}
            placeholder={t('inkPropertiesForm.pantoneMatchPlaceholder')}
            maxLength="20"
          />
        </div>
      </div>
    </div>
  );
};

export default InkPropertiesForm;